import { russianDefaultPaymentCards } from "app/constants/CurrencyConstants";

export const reducer: typeof window.kinosite.reducer = {
	cinema: {
		payment: {
			active: true,
			card: russianDefaultPaymentCards,
		},
		selectButton: {
			options: [
				{
					value: '//suncity-nk.ru',
					title: 'ТЦ Барс-3',
				},
				{
					value: '//ramusmall.suncity-nk.ru',
					title: 'ТЦ Рамус Молл',
				},
			],
			selectedOptionValue: '//suncity-nk.ru',
		},
		soonPageIsEnabled: false,
	},
	feedback: true,
};
